import firebase, { auth, googleAuth } from './config';
import * as db from './db';
export default firebase;
export { auth, googleAuth, db };
